import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Regioverantwoordelijke} from '../regioverantwoordelijke';
import {Page} from '../../core/pagination/page';
import {PageRequest} from '../../core/pagination/page-request';
import {SortOrder} from '../../core/sort/sort-order';

@Component({
    selector: 'zah-regioverantwoordelijken',
    templateUrl: './regioverantwoordelijken.component.html',
    styleUrls: ['./regioverantwoordelijken.component.scss'],
    standalone: false
})
export class RegioverantwoordelijkenComponent implements OnInit{

  @Input()
  initialPageRequest: PageRequest<Regioverantwoordelijke>;
  @Input()
  regioverantwoordelijkenPage: Page<Regioverantwoordelijke>;
  @Output()
  regioverantwoordelijkeClicked: EventEmitter<Regioverantwoordelijke> = new EventEmitter<Regioverantwoordelijke>();
  @Output()
  deleteClicked: EventEmitter<Regioverantwoordelijke> = new EventEmitter<Regioverantwoordelijke>();
  @Output()
  addClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  pageChange: EventEmitter<PageRequest<Regioverantwoordelijke>> = new EventEmitter<PageRequest<Regioverantwoordelijke>>();

  private currentPageRequest: PageRequest<Regioverantwoordelijke>;

  ngOnInit(): void {
    this.currentPageRequest = this.initialPageRequest;
  }

  onRegioverantwoordelijkeClick(regioverantwoordelijke: Regioverantwoordelijke): void {
    this.regioverantwoordelijkeClicked.emit(regioverantwoordelijke);
  }

  onDeleteClick(regioverantwoordelijke: Regioverantwoordelijke): void {
    this.deleteClicked.emit(regioverantwoordelijke);
  }

  onAddClick(): void {
    this.addClicked.emit();
  }

  onSortOrderChange(sortOrder: SortOrder): void {
    this.currentPageRequest = PageRequest.firstPageRequest<Regioverantwoordelijke>(sortOrder, this.currentPageRequest.getPageSize());
    this.pageChange.emit(this.currentPageRequest);
  }

  onPageSizeChange(pageSize: number): void {
    this.currentPageRequest = PageRequest.firstPageRequest<Regioverantwoordelijke>(this.currentPageRequest.getSortOrder(), pageSize);
    this.pageChange.emit(this.currentPageRequest);
  }

  onPageChange(pageRequest: PageRequest<Regioverantwoordelijke>): void {
    this.currentPageRequest = pageRequest;
    this.pageChange.emit(pageRequest);
  }
}
